import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import onClickOutside from 'react-onclickoutside';
import { ReactComponent as ZoomInIcon } from '@lifesize/ux-assets/vectors/svgIcons/zoom-in.svg';
import { ReactComponent as ZoomOutIcon } from '@lifesize/ux-assets/vectors/svgIcons/zoom-out.svg';
import Button from 'components/Button/Button';
import classes from 'components/FarEndCameraControls/FarEndCameraControls.module.scss';

class FarEndCameraControls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      panningLeft: false,
      tiltingUp: false,
      panningRight: false,
      tiltingDown: false,
      zoomingIn: false,
      zoomingOut: false,
      mouseIsDown: false
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
    document.addEventListener('keyup', this.onKeyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
    document.removeEventListener('keyup', this.onKeyUp, false);
  }

  onKeyDown = (e) => {
    switch (e.which) {
      case 37:
        if (this.state.panningLeft) return null;
        this.setState({ panningLeft: true });
        return this.props.panLeft();
      case 38:
        if (this.state.tiltingUp) return null;
        this.setState({ tiltingUp: true });
        return this.props.tiltUp();
      case 39:
        if (this.state.panningRight) return null;
        this.setState({ panningRight: true });
        return this.props.panRight();
      case 40:
        if (this.state.tiltingDown) return null;
        this.setState({ tiltingDown: true });
        return this.props.tiltDown();
      case 107:
        if (this.state.zoomingIn) return null;
        this.setState({ zoomingIn: true });
        return this.props.zoomIn();
      case 109:
        if (this.state.zoomingOut) return null;
        this.setState({ zoomingOut: true });
        return this.props.zoomOut();
      default:
        return null;
    }
  };

  onKeyUp = (e) => {
    switch (e.which) {
      case 37:
        this.setState({ panningLeft: false });
        return this.props.panLeftStop();
      case 38:
        this.setState({ tiltingUp: false });
        return this.props.tiltUpStop();
      case 39:
        this.setState({ panningRight: false });
        return this.props.panRightStop();
      case 40:
        this.setState({ tiltingDown: false });
        return this.props.tiltDownStop();
      case 107:
        this.setState({ zoomingIn: false });
        return this.props.zoomInStop();
      case 109:
        this.setState({ zoomingOut: false });
        return this.props.zoomOutStop();
      default:
        return null;
    }
  };

  onMouseLeave = () => {
    if (!this.state.mouseIsDown) return;
    this.setState({
      panningLeft: false,
      tiltingUp: false,
      panningRight: false,
      tiltingDown: false,
      zoomingOut: false,
      zoomingIn: false,
      mouseIsDown: false
    });
  };

  handleMouseUp = (type) => {
    this.setState({ mouseIsDown: false });
    switch (type) {
      case 'panLeft':
        this.setState({ panningLeft: false });
        return this.props.panLeftStop();
      case 'tiltUp':
        this.setState({ tiltingUp: false });
        return this.props.tiltUpStop();
      case 'panRight':
        this.setState({ panningRight: false });
        return this.props.panRightStop();
      case 'tiltDown':
        this.setState({ tiltingDown: false });
        return this.props.tiltDownStop();
      case 'zoomOut':
        this.setState({ zoomingOut: false });
        return this.props.zoomOutStop();
      case 'zoomIn':
        this.setState({ zoomingIn: false });
        return this.props.zoomInStop();
      default:
        return null;
    }
  };

  handleMouseDown = (type) => {
    this.setState({ mouseIsDown: true });
    switch (type) {
      case 'panLeft':
        if (this.state.panningLeft) return null;
        this.setState({ panningLeft: true });
        return this.props.panLeft();
      case 'tiltUp':
        if (this.state.tiltingUp) return null;
        this.setState({ tiltingUp: true });
        return this.props.tiltUp();
      case 'panRight':
        if (this.state.panningRight) return null;
        this.setState({ panningRight: true });
        return this.props.panRight();
      case 'tiltDown':
        if (this.state.tiltingDown) return null;
        this.setState({ tiltingDown: true });
        return this.props.tiltDown();
      case 'zoomOut':
        if (this.state.zoomingOut) return null;
        this.setState({ zoomingOut: true });
        return this.props.zoomOut();
      case 'zoomIn':
        if (this.state.zoomingIn) return null;
        this.setState({ zoomingIn: true });
        return this.props.zoomIn();
      default:
        return null;
    }
  };

  handleClickOutside() {
    this.props.closeControls();
  }

  render() {
    const { closeControls } = this.props;
    return (
      <div className={classes.cameraControls} onMouseDown={this.onMouseDown} onMouseLeave={this.onMouseLeave}>
        <div className={classes.controlContent}>
          <div className={classes.directionWheel}>
            <div className={classes.half}>
              <div
                className={`${classes.quarter} ${classes.tiltUp} ${this.state.tiltingUp ? classes.active : ''}`}
                onMouseDown={() => {
                  this.handleMouseDown('tiltUp');
                }}
                onMouseUp={() => {
                  this.handleMouseUp('tiltUp');
                }}
              />
              <div
                className={`${classes.quarter} ${classes.panRight} ${this.state.panningRight ? classes.active : ''}`}
                onMouseDown={() => {
                  this.handleMouseDown('panRight');
                }}
                onMouseUp={() => {
                  this.handleMouseUp('panRight');
                }}
              />
            </div>
            <div className={classes.half}>
              <div
                className={`${classes.quarter} ${classes.panLeft} ${this.state.panningLeft ? classes.active : ''}`}
                onMouseDown={() => {
                  this.handleMouseDown('panLeft');
                }}
                onMouseUp={() => {
                  this.handleMouseUp('panLeft');
                }}
              />
              <div
                className={`${classes.quarter} ${classes.tiltDown} ${this.state.tiltingDown ? classes.active : ''}`}
                onMouseDown={() => {
                  this.handleMouseDown('tiltDown');
                }}
                onMouseUp={() => {
                  this.handleMouseUp('tiltDown');
                }}
              />
            </div>
          </div>
          <div className={classes.zoomBar}>
            <section
              className={`${classes.zoomOut} ${this.state.zoomingOut ? classes.active : ''}`}
              onMouseDown={() => {
                this.handleMouseDown('zoomOut');
              }}
              onMouseUp={() => {
                this.handleMouseUp('zoomOut');
              }}
            >
              <ZoomOutIcon data-testid="zoomOutIcon" />
            </section>
            <section
              className={`${classes.zoomIn} ${this.state.zoomingIn ? classes.active : ''}`}
              onMouseDown={() => {
                this.handleMouseDown('zoomIn');
              }}
              onMouseUp={() => {
                this.handleMouseUp('zoomIn');
              }}
            >
              <ZoomInIcon data-testid="zoomInIcon" />
            </section>
          </div>
        </div>
        <div className={classes.buttonBlock}>
          <Button
            kind="primary"
            style={{
              minWidth: '101px',
              width: '101px',
              height: '32px',
              fontSize: '14px',
              lineHeight: '32px',
              padding: '0'
            }}
            onClick={closeControls}
          >
            <FormattedMessage id="components.farEndCameraControls.close" defaultMessage="Close" />
          </Button>
        </div>
      </div>
    );
  }
}

FarEndCameraControls.propTypes = {
  closeControls: PT.func.isRequired,
  panLeft: PT.func,
  panRight: PT.func,
  zoomIn: PT.func,
  zoomOut: PT.func,
  tiltUp: PT.func,
  tiltDown: PT.func,
  panLeftStop: PT.func,
  panRightStop: PT.func,
  zoomInStop: PT.func,
  zoomOutStop: PT.func,
  tiltUpStop: PT.func,
  tiltDownStop: PT.func
};

export default injectIntl(onClickOutside(FarEndCameraControls));
